import React, { Component } from "react";
import { multiLanguage } from "../../hoc";

@multiLanguage()
export default class Siteplan extends Component {
  render() {
    const { t, map } = this.props;
    return (
      <div className="section-siteplan villa">
        {/* <img src={map} className="siteplan-map" alt={t("Site Plan")} /> */}
        <svg viewBox="0 0 1630 1080">
          <image xlinkHref={map} x={0} y={0} width={1630} height={1080} />
        </svg>
        <div className="siteplan-name">{t("Site Plan")}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhuketLagunaVillageResidences/Siteplan.js